import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/prohibited-items-ebay';

export default function Example() {
  return (
    <>
      <Head>
        <title>Everything You Should Know About Prohibited Items On eBay</title>
        <meta
          name='description'
          content="Avoid making the mistake of listing prohibited and restricted items on eBay to keep your account out of trouble. Learn here everything you need to know about eBay's prohibited item policies."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-prohibited-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-prohibited-items' />
        <meta property='og:title' content='Everything You Should Know About Prohibited Items On eBay' />
        <meta
          property='og:description'
          content="Avoid making the mistake of listing prohibited and restricted items on eBay to keep your account out of trouble. Learn here everything you need to know about eBay's prohibited item policies."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
